import React from 'react';
import ActivosAsegurado from './index';

export default function Automoviles() {
    return (<ActivosAsegurado cClasif={'Automoviles'}  cTitulo ={'Automovil'}/>);
}
